/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { UserCollectionsState, UserCollection } from 'state/types'
import { fetchUserCollectionsDMD, fetchUserCollectionsWith, fetchNftsFromMoralis } from './fetchUserCollections'

const initialState: UserCollectionsState = {
  data: [],
  nftsFromMoralis: [],
  userDataLoaded: false,
}

export const fetchUserCollectionsDataAsync = (account: string) => async (dispatch, getState) => {
  const seriesUserDataLoaded = getState().serieses.userDataLoaded
  let userCollectionsDMD = []
  if (seriesUserDataLoaded) {
    userCollectionsDMD = await fetchUserCollectionsDMD(getState().serieses.data)
  }
  const nftsFromMoralis = await fetchNftsFromMoralis(account)
  dispatch(setNftsFromMoralisData(nftsFromMoralis))

  const userCollections = await fetchUserCollectionsWith(userCollectionsDMD, nftsFromMoralis)
  dispatch(setUserCollectionsData(userCollections))
}

export const UserCollectionsSlice = createSlice({
  name: 'UserCollections',
  initialState,
  reducers: {
    setUserCollectionsData: (state, action) => {
      const data: UserCollection[] = action.payload
      state.data = data
      state.userDataLoaded = true
    },
    setNftsFromMoralisData: (state, action) => {
      const data = action.payload
      state.nftsFromMoralis = data
    },
  },
})

// Actions
export const { setUserCollectionsData, setNftsFromMoralisData } = UserCollectionsSlice.actions

export default UserCollectionsSlice.reducer
